export default [
    {
        date: 1585306747372,
        row: 21,
        col: 21,
        squares: [
            [1, 11, "#000000"],
            [2, 11, "#000000"],
            [3, 11, "#000000"],
            [4, 11, "#000000"],
            [5, 11, "#000000"],
            [6, 11, "#000000"],
            [8, 11, "#000000"],
            [7, 11, "#000000"],
            [9, 11, "#000000"],
            [13, 11, "#000000"],
            [12, 11, "#000000"],
            [11, 11, "#000000"],
            [10, 11, "#000000"],
            [21, 11, "#000000"],
            [20, 11, "#000000"],
            [19, 11, "#000000"],
            [17, 11, "#000000"],
            [18, 11, "#000000"],
            [16, 11, "#000000"],
            [14, 11, "#000000"],
            [15, 11, "#000000"],
            [11, 12, "#000000"],
            [11, 10, "#000000"],
            [11, 13, "#000000"],
            [11, 14, "#000000"],
            [11, 15, "#000000"],
            [11, 16, "#000000"],
            [11, 17, "#000000"],
            [11, 21, "#000000"],
            [11, 19, "#000000"],
            [11, 20, "#000000"],
            [11, 18, "#000000"],
            [11, 1, "#000000"],
            [11, 2, "#000000"],
            [11, 3, "#000000"],
            [11, 9, "#000000"],
            [11, 8, "#000000"],
            [11, 7, "#000000"],
            [11, 4, "#000000"],
            [11, 5, "#000000"],
            [11, 6, "#000000"],
            [9, 12, "#FF9900"],
            [9, 13, "#FF9900"],
            [10, 13, "#FF9900"],
            [12, 9, "#FF9900"],
            [13, 9, "#FF9900"],
            [13, 10, "#FF9900"],
            [21, 20, "#FF9900"],
            [20, 20, "#FF9900"],
            [20, 21, "#FF9900"],
            [2, 1, "#FF9900"],
            [2, 2, "#FF9900"],
            [1, 2, "#FF9900"],
            [1, 12, "#FF0000"],
            [2, 12, "#00FFFF"],
            [3, 12, "#00FF00"],
            [4, 12, "#FFFF00"],
            [5, 12, "#FF00FF"],
            [6, 12, "#9900FF"],
            [7, 12, "#434343"],
            [8, 12, "#A61C00"],
            [1, 13, "#FF0000"],
            [10, 21, "#FF0000"],
            [9, 21, "#FF0000"],
            [8, 21, "#FF0000"],
            [7, 21, "#FF0000"],
            [6, 21, "#FF0000"],
            [5, 21, "#FF0000"],
            [1, 14, "#FF0000"],
            [1, 15, "#FF0000"],
            [1, 16, "#FF0000"],
            [1, 17, "#FF0000"],
            [1, 18, "#FF0000"],
            [4, 21, "#FF0000"],
            [3, 21, "#FF0000"],
            [2, 21, "#FF0000"],
            [1, 21, "#FF0000"],
            [1, 20, "#FF0000"],
            [1, 19, "#FF0000"],
            [8, 13, "#A61C00"],
            [8, 14, "#A61C00"],
            [9, 14, "#A61C00"],
            [10, 14, "#A61C00"],
            [7, 13, "#434343"],
            [10, 15, "#434343"],
            [9, 15, "#434343"],
            [8, 15, "#434343"],
            [7, 14, "#434343"],
            [7, 15, "#434343"],
            [5, 13, "#FF00FF"],
            [5, 14, "#FF00FF"],
            [5, 15, "#FF00FF"],
            [5, 16, "#FF00FF"],
            [5, 17, "#FF00FF"],
            [6, 17, "#FF00FF"],
            [7, 17, "#FF00FF"],
            [8, 17, "#FF00FF"],
            [9, 17, "#FF00FF"],
            [10, 17, "#FF00FF"],
            [10, 16, "#9900FF"],
            [8, 16, "#9900FF"],
            [9, 16, "#9900FF"],
            [6, 13, "#9900FF"],
            [6, 14, "#9900FF"],
            [6, 15, "#9900FF"],
            [6, 16, "#9900FF"],
            [7, 16, "#9900FF"],
            [4, 13, "#FFFF00"],
            [10, 18, "#FFFF00"],
            [9, 18, "#FFFF00"],
            [8, 18, "#FFFF00"],
            [7, 18, "#FFFF00"],
            [6, 18, "#FFFF00"],
            [5, 18, "#FFFF00"],
            [4, 18, "#FFFF00"],
            [4, 17, "#FFFF00"],
            [4, 16, "#FFFF00"],
            [4, 15, "#FFFF00"],
            [4, 14, "#FFFF00"],
            [3, 13, "#00FF00"],
            [10, 19, "#00FF00"],
            [9, 19, "#00FF00"],
            [7, 19, "#00FF00"],
            [8, 19, "#00FF00"],
            [6, 19, "#00FF00"],
            [5, 19, "#00FF00"],
            [4, 19, "#00FF00"],
            [3, 19, "#00FF00"],
            [3, 18, "#00FF00"],
            [3, 17, "#00FF00"],
            [3, 16, "#00FF00"],
            [3, 15, "#00FF00"],
            [3, 14, "#00FF00"],
            [2, 20, "#00FFFF"],
            [10, 20, "#00FFFF"],
            [9, 20, "#00FFFF"],
            [8, 20, "#00FFFF"],
            [7, 20, "#00FFFF"],
            [6, 20, "#00FFFF"],
            [5, 20, "#00FFFF"],
            [3, 20, "#00FFFF"],
            [4, 20, "#00FFFF"],
            [2, 13, "#00FFFF"],
            [2, 14, "#00FFFF"],
            [2, 15, "#00FFFF"],
            [2, 19, "#00FFFF"],
            [2, 18, "#00FFFF"],
            [2, 17, "#00FFFF"],
            [2, 16, "#00FFFF"],
            [12, 2, "#00FFFF"],
            [13, 2, "#00FFFF"],
            [14, 2, "#00FFFF"],
            [15, 2, "#00FFFF"],
            [16, 2, "#00FFFF"],
            [17, 2, "#00FFFF"],
            [18, 2, "#00FFFF"],
            [19, 2, "#00FFFF"],
            [20, 2, "#00FFFF"],
            [20, 3, "#00FFFF"],
            [20, 10, "#00FFFF"],
            [20, 9, "#00FFFF"],
            [20, 8, "#00FFFF"],
            [20, 7, "#00FFFF"],
            [20, 6, "#00FFFF"],
            [20, 5, "#00FFFF"],
            [20, 4, "#00FFFF"],
            [12, 1, "#A61C00"],
            [13, 1, "#A61C00"],
            [14, 1, "#A61C00"],
            [15, 1, "#A61C00"],
            [16, 1, "#A61C00"],
            [17, 1, "#A61C00"],
            [18, 1, "#A61C00"],
            [19, 1, "#A61C00"],
            [20, 1, "#A61C00"],
            [21, 1, "#A61C00"],
            [21, 2, "#A61C00"],
            [21, 3, "#A61C00"],
            [21, 4, "#A61C00"],
            [21, 5, "#A61C00"],
            [21, 10, "#A61C00"],
            [21, 9, "#A61C00"],
            [21, 8, "#A61C00"],
            [21, 7, "#A61C00"],
            [21, 6, "#A61C00"],
            [12, 4, "#FFFF00"],
            [13, 4, "#FFFF00"],
            [14, 4, "#FFFF00"],
            [18, 4, "#FFFF00"],
            [17, 4, "#FFFF00"],
            [16, 4, "#FFFF00"],
            [15, 4, "#FFFF00"],
            [18, 5, "#FFFF00"],
            [18, 6, "#FFFF00"],
            [18, 7, "#FFFF00"],
            [18, 8, "#FFFF00"],
            [18, 9, "#FFFF00"],
            [18, 10, "#FFFF00"],
            [12, 3, "#00FF00"],
            [19, 3, "#00FF00"],
            [19, 10, "#00FF00"],
            [19, 9, "#00FF00"],
            [19, 8, "#00FF00"],
            [19, 7, "#00FF00"],
            [19, 6, "#00FF00"],
            [19, 5, "#00FF00"],
            [19, 4, "#00FF00"],
            [18, 3, "#00FF00"],
            [17, 3, "#00FF00"],
            [16, 3, "#00FF00"],
            [15, 3, "#00FF00"],
            [14, 3, "#00FF00"],
            [13, 3, "#00FF00"],
            [12, 5, "#FF00FF"],
            [16, 5, "#FF00FF"],
            [17, 5, "#FF00FF"],
            [17, 6, "#FF00FF"],
            [17, 7, "#FF00FF"],
            [17, 10, "#FF00FF"],
            [17, 9, "#FF00FF"],
            [17, 8, "#FF00FF"],
            [15, 5, "#FF00FF"],
            [14, 5, "#FF00FF"],
            [13, 5, "#FF00FF"],
            [12, 6, "#9900FF"],
            [16, 10, "#9900FF"],
            [15, 6, "#9900FF"],
            [16, 6, "#9900FF"],
            [14, 6, "#9900FF"],
            [13, 6, "#9900FF"],
            [16, 7, "#9900FF"],
            [16, 8, "#9900FF"],
            [16, 9, "#9900FF"],
            [12, 8, "#A61C00"],
            [14, 10, "#A61C00"],
            [14, 8, "#A61C00"],
            [14, 9, "#A61C00"],
            [13, 8, "#A61C00"],
            [12, 7, "#434343"],
            [13, 7, "#434343"],
            [14, 7, "#434343"],
            [15, 7, "#434343"],
            [15, 10, "#434343"],
            [15, 9, "#434343"],
            [15, 8, "#434343"],
            [21, 18, "#434343"],
            [20, 18, "#434343"],
            [19, 18, "#434343"],
            [18, 18, "#434343"],
            [18, 19, "#434343"],
            [18, 20, "#434343"],
            [18, 21, "#434343"],
            [20, 19, "#A61C00"],
            [21, 19, "#A61C00"],
            [19, 21, "#A61C00"],
            [19, 20, "#A61C00"],
            [19, 19, "#A61C00"],
            [17, 17, "#9900FF"],
            [16, 16, "#FF00FF"],
            [15, 15, "#FFFF00"],
            [14, 14, "#00FF00"],
            [12, 12, "#FF0000"],
            [13, 13, "#00FFFF"],
            [10, 10, "#FF0000"],
            [3, 3, "#434343"],
            [4, 4, "#A61C00"],
            [5, 5, "#9900FF"],
            [6, 6, "#FF00FF"],
            [8, 8, "#00FF00"],
            [9, 9, "#00FFFF"],
            [14, 13, "#00FFFF"],
            [15, 13, "#00FFFF"],
            [16, 13, "#00FFFF"],
            [17, 13, "#00FFFF"],
            [18, 13, "#00FFFF"],
            [19, 13, "#00FFFF"],
            [20, 13, "#00FFFF"],
            [21, 13, "#00FFFF"],
            [9, 8, "#00FFFF"],
            [9, 7, "#00FFFF"],
            [9, 6, "#00FFFF"],
            [9, 5, "#00FFFF"],
            [9, 4, "#00FFFF"],
            [9, 3, "#00FFFF"],
            [9, 2, "#00FFFF"],
            [9, 1, "#00FFFF"],
            [13, 12, "#FF0000"],
            [14, 12, "#FF0000"],
            [15, 12, "#FF0000"],
            [16, 12, "#FF0000"],
            [17, 12, "#FF0000"],
            [18, 12, "#FF0000"],
            [19, 12, "#FF0000"],
            [20, 12, "#FF0000"],
            [21, 12, "#FF0000"],
            [10, 9, "#FF0000"],
            [10, 8, "#FF0000"],
            [10, 7, "#FF0000"],
            [10, 6, "#FF0000"],
            [10, 5, "#FF0000"],
            [10, 4, "#FF0000"],
            [10, 1, "#FF0000"],
            [10, 2, "#FF0000"],
            [10, 3, "#FF0000"],
            [8, 7, "#00FF00"],
            [8, 6, "#00FF00"],
            [8, 5, "#00FF00"],
            [8, 3, "#00FF00"],
            [8, 4, "#00FF00"],
            [8, 2, "#00FF00"],
            [8, 1, "#00FF00"],
            [7, 7, "#FFFF00"],
            [15, 14, "#00FF00"],
            [16, 14, "#00FF00"],
            [17, 14, "#00FF00"],
            [18, 14, "#00FF00"],
            [19, 14, "#00FF00"],
            [20, 14, "#00FF00"],
            [21, 14, "#00FF00"],
            [16, 15, "#FFFF00"],
            [17, 15, "#FFFF00"],
            [21, 15, "#FFFF00"],
            [20, 15, "#FFFF00"],
            [19, 15, "#FFFF00"],
            [18, 15, "#FFFF00"],
            [7, 6, "#FFFF00"],
            [7, 5, "#FFFF00"],
            [7, 1, "#FFFF00"],
            [7, 2, "#FFFF00"],
            [7, 3, "#FFFF00"],
            [7, 4, "#FFFF00"],
            [17, 16, "#FF00FF"],
            [18, 16, "#FF00FF"],
            [19, 16, "#FF00FF"],
            [20, 16, "#FF00FF"],
            [21, 16, "#FF00FF"],
            [6, 5, "#FF00FF"],
            [6, 4, "#FF00FF"],
            [6, 3, "#FF00FF"],
            [6, 2, "#FF00FF"],
            [6, 1, "#FF00FF"],
            [5, 4, "#9900FF"],
            [5, 3, "#9900FF"],
            [5, 2, "#9900FF"],
            [5, 1, "#9900FF"],
            [18, 17, "#9900FF"],
            [19, 17, "#9900FF"],
            [20, 17, "#9900FF"],
            [21, 17, "#9900FF"],
            [3, 2, "#434343"],
            [3, 1, "#434343"],
            [2, 3, "#434343"],
            [1, 3, "#434343"],
            [4, 1, "#A61C00"],
            [4, 2, "#A61C00"],
            [4, 3, "#A61C00"],
            [3, 4, "#A61C00"],
            [2, 4, "#A61C00"],
            [1, 4, "#A61C00"],
            [4, 5, "#9900FF"],
            [3, 5, "#9900FF"],
            [2, 5, "#9900FF"],
            [1, 5, "#9900FF"],
            [17, 18, "#9900FF"],
            [17, 19, "#9900FF"],
            [17, 20, "#9900FF"],
            [17, 21, "#9900FF"],
            [5, 6, "#FF00FF"],
            [4, 6, "#FF00FF"],
            [3, 6, "#FF00FF"],
            [1, 6, "#FF00FF"],
            [2, 6, "#FF00FF"],
            [16, 17, "#FF00FF"],
            [16, 21, "#FF00FF"],
            [16, 20, "#FF00FF"],
            [16, 19, "#FF00FF"],
            [16, 18, "#FF00FF"],
            [6, 7, "#FFFF00"],
            [5, 7, "#FFFF00"],
            [4, 7, "#FFFF00"],
            [3, 7, "#FFFF00"],
            [2, 7, "#FFFF00"],
            [1, 7, "#FFFF00"],
            [15, 16, "#FFFF00"],
            [15, 17, "#FFFF00"],
            [15, 21, "#FFFF00"],
            [15, 20, "#FFFF00"],
            [15, 19, "#FFFF00"],
            [15, 18, "#FFFF00"],
            [7, 8, "#00FF00"],
            [1, 8, "#00FF00"],
            [2, 8, "#00FF00"],
            [6, 8, "#00FF00"],
            [5, 8, "#00FF00"],
            [3, 8, "#00FF00"],
            [4, 8, "#00FF00"],
            [14, 15, "#00FF00"],
            [14, 16, "#00FF00"],
            [14, 21, "#00FF00"],
            [14, 20, "#00FF00"],
            [14, 19, "#00FF00"],
            [14, 18, "#00FF00"],
            [14, 17, "#00FF00"],
            [8, 9, "#00FFFF"],
            [7, 9, "#00FFFF"],
            [1, 9, "#00FFFF"],
            [2, 9, "#00FFFF"],
            [3, 9, "#00FFFF"],
            [4, 9, "#00FFFF"],
            [6, 9, "#00FFFF"],
            [5, 9, "#00FFFF"],
            [13, 14, "#00FFFF"],
            [13, 21, "#00FFFF"],
            [13, 20, "#00FFFF"],
            [13, 15, "#00FFFF"],
            [13, 19, "#00FFFF"],
            [13, 16, "#00FFFF"],
            [13, 18, "#00FFFF"],
            [13, 17, "#00FFFF"],
            [1, 10, "#FF0000"],
            [5, 10, "#FF0000"],
            [9, 10, "#FF0000"],
            [8, 10, "#FF0000"],
            [7, 10, "#FF0000"],
            [6, 10, "#FF0000"],
            [4, 10, "#FF0000"],
            [3, 10, "#FF0000"],
            [2, 10, "#FF0000"],
            [12, 13, "#FF0000"],
            [12, 21, "#FF0000"],
            [12, 17, "#FF0000"],
            [12, 14, "#FF0000"],
            [12, 20, "#FF0000"],
            [12, 19, "#FF0000"],
            [12, 15, "#FF0000"],
            [12, 16, "#FF0000"],
            [12, 18, "#FF0000"],
        ],
    },
    {
        date: 1530259292485,
        row: 21,
        col: 21,
        squares: [
            [7, 4, "#000000"],
            [6, 4, "#000000"],
            [5, 4, "#000000"],
            [4, 4, "#000000"],
            [3, 4, "#000000"],
            [2, 5, "#000000"],
            [3, 6, "#000000"],
            [5, 6, "#000000"],
            [6, 6, "#000000"],
            [7, 6, "#000000"],
            [4, 6, "#000000"],
            [3, 18, "#000000"],
            [4, 18, "#000000"],
            [5, 18, "#000000"],
            [6, 18, "#000000"],
            [7, 18, "#000000"],
            [2, 17, "#000000"],
            [3, 16, "#000000"],
            [4, 16, "#000000"],
            [5, 16, "#000000"],
            [6, 16, "#000000"],
            [7, 16, "#000000"],
            [8, 7, "#000000"],
            [8, 8, "#000000"],
            [8, 9, "#000000"],
            [8, 10, "#000000"],
            [8, 11, "#000000"],
            [8, 12, "#000000"],
            [8, 13, "#000000"],
            [8, 14, "#000000"],
            [8, 15, "#000000"],
            [8, 19, "#000000"],
            [9, 19, "#000000"],
            [10, 19, "#000000"],
            [11, 19, "#000000"],
            [12, 19, "#000000"],
            [13, 19, "#000000"],
            [14, 18, "#000000"],
            [16, 16, "#000000"],
            [15, 17, "#000000"],
            [8, 3, "#000000"],
            [9, 3, "#000000"],
            [10, 3, "#000000"],
            [11, 3, "#000000"],
            [13, 3, "#000000"],
            [12, 3, "#000000"],
            [14, 4, "#000000"],
            [15, 5, "#000000"],
            [16, 6, "#000000"],
            [17, 7, "#000000"],
            [18, 8, "#000000"],
            [19, 9, "#000000"],
            [17, 15, "#000000"],
            [18, 14, "#000000"],
            [19, 13, "#000000"],
            [20, 12, "#000000"],
            [20, 10, "#000000"],
            [20, 11, "#000000"],
            [15, 8, "#000000"],
            [15, 9, "#000000"],
            [15, 10, "#000000"],
            [15, 11, "#000000"],
            [15, 12, "#000000"],
            [16, 13, "#FF0000"],
            [15, 14, "#000000"],
            [15, 13, "#000000"],
            [17, 13, "#FF0000"],
            [16, 9, "#FF0000"],
            [17, 9, "#FF0000"],
            [12, 11, "#FF00FF"],
            [11, 11, "#FF00FF"],
            [12, 10, "#FF00FF"],
            [12, 12, "#FF00FF"],
            [9, 5, "#000000"],
            [11, 7, "#000000"],
            [10, 6, "#000000"],
            [10, 4, "#000000"],
            [11, 4, "#000000"],
            [12, 5, "#000000"],
            [12, 6, "#000000"],
            [9, 17, "#000000"],
            [10, 16, "#000000"],
            [11, 15, "#000000"],
            [12, 16, "#000000"],
            [12, 17, "#000000"],
            [11, 18, "#000000"],
            [10, 18, "#000000"],
            [11, 17, "#00FFFF"],
            [11, 5, "#00FFFF"],
            [10, 17, "#0000FF"],
            [11, 16, "#0000FF"],
            [10, 5, "#0000FF"],
            [11, 6, "#0000FF"],
            [9, 15, "#FF9900"],
            [10, 14, "#FF9900"],
            [11, 14, "#666666"],
            [12, 14, "#FF9900"],
            [13, 14, "#FF9900"],
            [14, 15, "#FF9900"],
            [15, 16, "#FF9900"],
            [14, 16, "#FF9900"],
            [14, 17, "#FF9900"],
            [13, 17, "#666666"],
            [12, 18, "#666666"],
            [13, 18, "#FF9900"],
            [13, 16, "#666666"],
            [13, 15, "#FF9900"],
            [12, 15, "#666666"],
            [10, 15, "#666666"],
            [9, 16, "#666666"],
            [8, 16, "#FF9900"],
            [8, 17, "#666666"],
            [8, 18, "#FF9900"],
            [9, 18, "#666666"],
            [8, 6, "#FF9900"],
            [8, 5, "#666666"],
            [8, 4, "#FF9900"],
            [9, 4, "#666666"],
            [9, 6, "#666666"],
            [9, 7, "#FF9900"],
            [10, 7, "#666666"],
            [10, 8, "#FF9900"],
            [11, 8, "#666666"],
            [12, 8, "#FF9900"],
            [13, 8, "#FF9900"],
            [14, 7, "#FF9900"],
            [14, 6, "#FF9900"],
            [13, 6, "#666666"],
            [13, 7, "#FF9900"],
            [12, 7, "#666666"],
            [15, 6, "#FF9900"],
            [14, 5, "#FF9900"],
            [13, 5, "#666666"],
            [12, 4, "#666666"],
            [13, 4, "#FF9900"],
            [17, 11, "#FF0000"],
            [17, 12, "#FF0000"],
            [16, 12, "#FF0000"],
            [16, 11, "#FF0000"],
            [16, 10, "#FF0000"],
            [17, 10, "#FF0000"],
            [13, 9, "#666666"],
            [14, 10, "#FF9900"],
            [14, 12, "#FF9900"],
            [14, 11, "#FF9900"],
            [13, 13, "#666666"],
            [9, 8, "#666666"],
            [9, 9, "#666666"],
            [9, 10, "#FF9900"],
            [10, 11, "#FF9900"],
            [9, 12, "#FF9900"],
            [10, 12, "#FF9900"],
            [10, 13, "#666666"],
            [9, 13, "#666666"],
            [9, 14, "#666666"],
            [9, 11, "#FF9900"],
            [10, 10, "#FF9900"],
            [11, 9, "#666666"],
            [10, 9, "#666666"],
            [12, 9, "#666666"],
            [11, 13, "#666666"],
            [12, 13, "#666666"],
            [11, 12, "#FF9900"],
            [11, 10, "#FF9900"],
            [13, 12, "#FF9900"],
            [13, 10, "#FF9900"],
            [13, 11, "#FF9900"],
            [14, 13, "#666666"],
            [14, 8, "#666666"],
            [14, 9, "#666666"],
            [15, 7, "#FF9900"],
            [16, 7, "#666666"],
            [16, 8, "#666666"],
            [17, 8, "#FF9900"],
            [18, 9, "#666666"],
            [18, 10, "#FF9900"],
            [18, 11, "#FF9900"],
            [18, 12, "#FF9900"],
            [18, 13, "#666666"],
            [19, 12, "#FF9900"],
            [19, 11, "#FF9900"],
            [19, 10, "#FF9900"],
            [17, 14, "#FF9900"],
            [16, 14, "#666666"],
            [16, 15, "#666666"],
            [15, 15, "#FF9900"],
            [14, 14, "#666666"],
        ],
    },

    {
        date: 1494943165556,
        row: 21,
        col: 21,
        squares: [
            [11, 21, "#000000"],
            [11, 20, "#000000"],
            [11, 19, "#000000"],
            [11, 18, "#000000"],
            [11, 17, "#000000"],
            [11, 16, "#000000"],
            [11, 15, "#000000"],
            [11, 14, "#000000"],
            [11, 13, "#000000"],
            [11, 12, "#000000"],
            [11, 10, "#000000"],
            [11, 9, "#000000"],
            [11, 11, "#000000"],
            [11, 8, "#000000"],
            [11, 7, "#000000"],
            [11, 6, "#000000"],
            [11, 4, "#000000"],
            [11, 3, "#000000"],
            [11, 1, "#000000"],
            [11, 2, "#000000"],
            [11, 5, "#000000"],
            [1, 11, "#000000"],
            [2, 11, "#000000"],
            [3, 11, "#000000"],
            [5, 11, "#000000"],
            [4, 11, "#000000"],
            [6, 11, "#000000"],
            [7, 11, "#000000"],
            [8, 11, "#000000"],
            [9, 11, "#000000"],
            [10, 11, "#000000"],
            [12, 11, "#000000"],
            [13, 11, "#000000"],
            [14, 11, "#000000"],
            [15, 11, "#000000"],
            [16, 11, "#000000"],
            [17, 11, "#000000"],
            [18, 11, "#000000"],
            [19, 11, "#000000"],
            [21, 11, "#000000"],
            [20, 11, "#000000"],
            [1, 10, "#FF0000"],
            [3, 10, "#FF0000"],
            [2, 10, "#FF0000"],
            [4, 10, "#FF0000"],
            [5, 10, "#FF0000"],
            [6, 10, "#FF0000"],
            [8, 10, "#FF0000"],
            [9, 10, "#FF0000"],
            [7, 10, "#FF0000"],
            [10, 10, "#FF0000"],
            [10, 9, "#FF0000"],
            [10, 8, "#FF0000"],
            [10, 7, "#FF0000"],
            [10, 5, "#FF0000"],
            [10, 6, "#FF0000"],
            [10, 4, "#FF0000"],
            [10, 3, "#FF0000"],
            [10, 2, "#FF0000"],
            [10, 1, "#FF0000"],
            [1, 12, "#FF0000"],
            [1, 13, "#FF0000"],
            [1, 14, "#FF0000"],
            [1, 15, "#FF0000"],
            [1, 16, "#FF0000"],
            [1, 17, "#FF0000"],
            [1, 18, "#FF0000"],
            [1, 19, "#FF0000"],
            [1, 20, "#FF0000"],
            [1, 21, "#FF0000"],
            [2, 21, "#FF0000"],
            [3, 21, "#FF0000"],
            [4, 21, "#FF0000"],
            [5, 21, "#FF0000"],
            [6, 21, "#FF0000"],
            [7, 21, "#FF0000"],
            [8, 21, "#FF0000"],
            [9, 21, "#FF0000"],
            [10, 21, "#FF0000"],
            [12, 21, "#FF0000"],
            [12, 19, "#FF0000"],
            [12, 18, "#FF0000"],
            [12, 20, "#FF0000"],
            [12, 17, "#FF0000"],
            [12, 16, "#FF0000"],
            [12, 14, "#FF0000"],
            [12, 13, "#FF0000"],
            [12, 12, "#FF0000"],
            [13, 12, "#FF0000"],
            [14, 12, "#FF0000"],
            [15, 12, "#FF0000"],
            [16, 12, "#FF0000"],
            [17, 12, "#FF0000"],
            [18, 12, "#FF0000"],
            [19, 12, "#FF0000"],
            [20, 12, "#FF0000"],
            [21, 12, "#FF0000"],
            [12, 15, "#FF0000"],
            [21, 9, "#FF0000"],
            [21, 8, "#FF0000"],
            [21, 10, "#FF0000"],
            [21, 7, "#FF0000"],
            [21, 6, "#FF0000"],
            [21, 3, "#FF0000"],
            [21, 1, "#FF0000"],
            [20, 1, "#FF0000"],
            [19, 1, "#FF0000"],
            [17, 1, "#FF0000"],
            [16, 1, "#FF0000"],
            [12, 1, "#FF0000"],
            [13, 1, "#FF0000"],
            [15, 1, "#FF0000"],
            [14, 1, "#FF0000"],
            [21, 2, "#FF0000"],
            [21, 4, "#FF0000"],
            [21, 5, "#FF0000"],
            [18, 1, "#FF0000"],
            [2, 12, "#00FFFF"],
            [2, 13, "#00FFFF"],
            [2, 15, "#00FFFF"],
            [2, 16, "#00FFFF"],
            [2, 14, "#00FFFF"],
            [2, 18, "#00FFFF"],
            [2, 19, "#00FFFF"],
            [2, 20, "#00FFFF"],
            [3, 20, "#00FFFF"],
            [4, 20, "#00FFFF"],
            [5, 20, "#00FFFF"],
            [9, 20, "#00FFFF"],
            [10, 20, "#00FFFF"],
            [7, 20, "#00FFFF"],
            [6, 20, "#00FFFF"],
            [8, 20, "#00FFFF"],
            [2, 17, "#00FFFF"],
            [1, 9, "#00FFFF"],
            [3, 9, "#00FFFF"],
            [4, 9, "#00FFFF"],
            [5, 9, "#00FFFF"],
            [2, 9, "#00FFFF"],
            [6, 9, "#00FFFF"],
            [9, 1, "#00FFFF"],
            [9, 2, "#00FFFF"],
            [9, 3, "#00FFFF"],
            [9, 4, "#00FFFF"],
            [9, 5, "#00FFFF"],
            [9, 6, "#00FFFF"],
            [8, 9, "#00FFFF"],
            [7, 9, "#00FFFF"],
            [9, 9, "#00FFFF"],
            [9, 8, "#00FFFF"],
            [9, 7, "#00FFFF"],
            [13, 21, "#00FFFF"],
            [13, 20, "#00FFFF"],
            [13, 18, "#00FFFF"],
            [13, 17, "#00FFFF"],
            [13, 19, "#00FFFF"],
            [13, 16, "#00FFFF"],
            [13, 15, "#00FFFF"],
            [13, 14, "#00FFFF"],
            [13, 13, "#00FFFF"],
            [14, 13, "#00FFFF"],
            [15, 13, "#00FFFF"],
            [16, 13, "#00FFFF"],
            [18, 13, "#00FFFF"],
            [19, 13, "#00FFFF"],
            [20, 13, "#00FFFF"],
            [21, 13, "#00FFFF"],
            [17, 13, "#00FFFF"],
            [12, 2, "#00FFFF"],
            [13, 2, "#00FFFF"],
            [14, 2, "#00FFFF"],
            [15, 2, "#00FFFF"],
            [17, 2, "#00FFFF"],
            [18, 2, "#00FFFF"],
            [16, 2, "#00FFFF"],
            [19, 2, "#00FFFF"],
            [20, 2, "#00FFFF"],
            [20, 3, "#00FFFF"],
            [20, 4, "#00FFFF"],
            [20, 6, "#00FFFF"],
            [20, 7, "#00FFFF"],
            [20, 8, "#00FFFF"],
            [20, 10, "#00FFFF"],
            [20, 9, "#00FFFF"],
            [20, 5, "#00FFFF"],
            [3, 12, "#00FF00"],
            [3, 13, "#00FF00"],
            [3, 14, "#00FF00"],
            [3, 16, "#00FF00"],
            [3, 15, "#00FF00"],
            [3, 17, "#00FF00"],
            [3, 18, "#00FF00"],
            [3, 19, "#00FF00"],
            [4, 19, "#00FF00"],
            [5, 19, "#00FF00"],
            [6, 19, "#00FF00"],
            [7, 19, "#00FF00"],
            [8, 19, "#00FF00"],
            [9, 19, "#00FF00"],
            [10, 19, "#00FF00"],
            [14, 21, "#00FF00"],
            [14, 19, "#00FF00"],
            [14, 18, "#00FF00"],
            [14, 20, "#00FF00"],
            [14, 17, "#00FF00"],
            [14, 15, "#00FF00"],
            [14, 14, "#00FF00"],
            [14, 16, "#00FF00"],
            [15, 14, "#00FF00"],
            [16, 14, "#00FF00"],
            [18, 14, "#00FF00"],
            [19, 14, "#00FF00"],
            [20, 14, "#00FF00"],
            [21, 14, "#00FF00"],
            [17, 14, "#00FF00"],
            [1, 8, "#00FF00"],
            [2, 8, "#00FF00"],
            [3, 8, "#00FF00"],
            [5, 8, "#00FF00"],
            [6, 8, "#00FF00"],
            [4, 8, "#00FF00"],
            [7, 8, "#00FF00"],
            [8, 8, "#00FF00"],
            [8, 7, "#00FF00"],
            [8, 6, "#00FF00"],
            [8, 5, "#00FF00"],
            [8, 4, "#00FF00"],
            [8, 3, "#00FF00"],
            [8, 2, "#00FF00"],
            [8, 1, "#00FF00"],
            [12, 3, "#00FF00"],
            [14, 3, "#00FF00"],
            [15, 3, "#00FF00"],
            [13, 3, "#00FF00"],
            [17, 3, "#00FF00"],
            [18, 3, "#00FF00"],
            [19, 3, "#00FF00"],
            [16, 3, "#00FF00"],
            [19, 4, "#00FF00"],
            [19, 6, "#00FF00"],
            [19, 7, "#00FF00"],
            [19, 9, "#00FF00"],
            [19, 10, "#00FF00"],
            [19, 8, "#00FF00"],
            [19, 5, "#00FF00"],
            [4, 12, "#FFFF00"],
            [4, 13, "#FFFF00"],
            [4, 15, "#FFFF00"],
            [4, 16, "#FFFF00"],
            [4, 17, "#FFFF00"],
            [4, 18, "#FFFF00"],
            [4, 14, "#FFFF00"],
            [5, 18, "#FFFF00"],
            [6, 18, "#FFFF00"],
            [7, 18, "#FFFF00"],
            [8, 18, "#FFFF00"],
            [9, 18, "#FFFF00"],
            [10, 18, "#FFFF00"],
            [12, 4, "#FFFF00"],
            [13, 4, "#FFFF00"],
            [14, 4, "#FFFF00"],
            [15, 4, "#FFFF00"],
            [17, 4, "#FFFF00"],
            [16, 4, "#FFFF00"],
            [18, 4, "#FFFF00"],
            [18, 5, "#FFFF00"],
            [18, 6, "#FFFF00"],
            [18, 8, "#FFFF00"],
            [18, 10, "#FFFF00"],
            [18, 9, "#FFFF00"],
            [18, 7, "#FFFF00"],
            [15, 15, "#FFFF00"],
            [16, 15, "#FFFF00"],
            [17, 15, "#FFFF00"],
            [18, 15, "#FFFF00"],
            [19, 15, "#FFFF00"],
            [20, 15, "#FFFF00"],
            [21, 15, "#FFFF00"],
            [15, 16, "#FFFF00"],
            [15, 17, "#FFFF00"],
            [15, 19, "#FFFF00"],
            [15, 20, "#FFFF00"],
            [15, 21, "#FFFF00"],
            [15, 18, "#FFFF00"],
            [1, 7, "#FFFF00"],
            [3, 7, "#FFFF00"],
            [4, 7, "#FFFF00"],
            [2, 7, "#FFFF00"],
            [5, 7, "#FFFF00"],
            [6, 7, "#FFFF00"],
            [7, 7, "#FFFF00"],
            [7, 6, "#FFFF00"],
            [7, 5, "#FFFF00"],
            [7, 4, "#FFFF00"],
            [7, 3, "#FFFF00"],
            [7, 2, "#FFFF00"],
            [7, 1, "#FFFF00"],
            [5, 12, "#FF00FF"],
            [5, 13, "#FF00FF"],
            [5, 15, "#FF00FF"],
            [5, 16, "#FF00FF"],
            [5, 17, "#FF00FF"],
            [6, 17, "#FF00FF"],
            [7, 17, "#FF00FF"],
            [8, 17, "#FF00FF"],
            [9, 17, "#FF00FF"],
            [10, 17, "#FF00FF"],
            [5, 14, "#FF00FF"],
            [1, 6, "#FF00FF"],
            [2, 6, "#FF00FF"],
            [3, 6, "#FF00FF"],
            [4, 6, "#FF00FF"],
            [5, 6, "#FF00FF"],
            [6, 6, "#FF00FF"],
            [6, 5, "#FF00FF"],
            [6, 4, "#FF00FF"],
            [6, 3, "#FF00FF"],
            [6, 2, "#FF00FF"],
            [6, 1, "#FF00FF"],
            [12, 5, "#FF00FF"],
            [13, 5, "#FF00FF"],
            [14, 5, "#FF00FF"],
            [15, 5, "#FF00FF"],
            [16, 5, "#FF00FF"],
            [17, 5, "#FF00FF"],
            [17, 6, "#FF00FF"],
            [17, 7, "#FF00FF"],
            [17, 8, "#FF00FF"],
            [17, 10, "#FF00FF"],
            [17, 9, "#FF00FF"],
            [16, 16, "#FF00FF"],
            [16, 17, "#FF00FF"],
            [16, 18, "#FF00FF"],
            [16, 19, "#FF00FF"],
            [16, 21, "#FF00FF"],
            [16, 20, "#FF00FF"],
            [17, 16, "#FF00FF"],
            [18, 16, "#FF00FF"],
            [19, 16, "#FF00FF"],
            [20, 16, "#FF00FF"],
            [21, 16, "#FF00FF"],
            [1, 4, "#434343"],
            [2, 4, "#434343"],
            [3, 4, "#434343"],
            [4, 4, "#434343"],
            [4, 3, "#434343"],
            [4, 2, "#434343"],
            [4, 1, "#434343"],
            [7, 12, "#434343"],
            [7, 13, "#434343"],
            [7, 14, "#434343"],
            [7, 15, "#434343"],
            [8, 15, "#434343"],
            [9, 15, "#434343"],
            [10, 15, "#434343"],
            [18, 21, "#434343"],
            [18, 19, "#434343"],
            [18, 18, "#434343"],
            [18, 20, "#434343"],
            [19, 18, "#434343"],
            [20, 18, "#434343"],
            [21, 18, "#434343"],
            [15, 10, "#434343"],
            [15, 8, "#434343"],
            [15, 7, "#434343"],
            [13, 7, "#434343"],
            [12, 7, "#434343"],
            [14, 7, "#434343"],
            [15, 9, "#434343"],
            [6, 12, "#9900FF"],
            [6, 13, "#9900FF"],
            [6, 14, "#9900FF"],
            [6, 15, "#9900FF"],
            [6, 16, "#9900FF"],
            [7, 16, "#9900FF"],
            [8, 16, "#9900FF"],
            [9, 16, "#9900FF"],
            [10, 16, "#9900FF"],
            [17, 21, "#9900FF"],
            [17, 20, "#9900FF"],
            [17, 19, "#9900FF"],
            [17, 18, "#9900FF"],
            [17, 17, "#9900FF"],
            [18, 17, "#9900FF"],
            [20, 17, "#9900FF"],
            [21, 17, "#9900FF"],
            [19, 17, "#9900FF"],
            [16, 10, "#9900FF"],
            [16, 8, "#9900FF"],
            [16, 7, "#9900FF"],
            [16, 9, "#9900FF"],
            [15, 6, "#9900FF"],
            [16, 6, "#9900FF"],
            [14, 6, "#9900FF"],
            [13, 6, "#9900FF"],
            [12, 6, "#9900FF"],
            [1, 5, "#9900FF"],
            [3, 5, "#9900FF"],
            [4, 5, "#9900FF"],
            [2, 5, "#9900FF"],
            [5, 5, "#9900FF"],
            [5, 4, "#9900FF"],
            [5, 3, "#9900FF"],
            [5, 2, "#9900FF"],
            [5, 1, "#9900FF"],
            [1, 3, "#A61C00"],
            [2, 3, "#A61C00"],
            [3, 3, "#A61C00"],
            [3, 1, "#A61C00"],
            [3, 2, "#A61C00"],
            [8, 12, "#A61C00"],
            [8, 13, "#A61C00"],
            [8, 14, "#A61C00"],
            [9, 14, "#A61C00"],
            [10, 14, "#A61C00"],
            [12, 8, "#A61C00"],
            [13, 8, "#A61C00"],
            [14, 8, "#A61C00"],
            [14, 9, "#A61C00"],
            [14, 10, "#A61C00"],
            [19, 20, "#A61C00"],
            [19, 19, "#A61C00"],
            [19, 21, "#A61C00"],
            [20, 19, "#A61C00"],
            [21, 19, "#A61C00"],
            [1, 2, "#FF9900"],
            [2, 2, "#FF9900"],
            [2, 1, "#FF9900"],
            [9, 12, "#FF9900"],
            [9, 13, "#FF9900"],
            [10, 13, "#FF9900"],
            [20, 21, "#FF9900"],
            [20, 20, "#FF9900"],
            [21, 20, "#FF9900"],
            [13, 10, "#FF9900"],
            [13, 9, "#FF9900"],
            [12, 9, "#FF9900"],
        ],
    },
    {
        date: 1485597882474,
        row: 21,
        col: 21,
        squares: [
            [7, 10, "#FF0000"],
            [6, 9, "#FF0000"],
            [5, 8, "#FF0000"],
            [8, 6, "#FF0000"],
            [9, 6, "#FF0000"],
            [10, 6, "#FF0000"],
            [11, 8, "#FF0000"],
            [12, 9, "#FF0000"],
            [13, 10, "#FF0000"],
            [14, 11, "#FF0000"],
            [7, 11, "#800000"],
            [5, 14, "#FF0000"],
            [6, 15, "#FF0000"],
            [8, 15, "#FF0000"],
            [10, 14, "#FF0000"],
            [11, 13, "#FF0000"],
            [13, 13, "#FF0000"],
            [14, 12, "#FF0000"],
            [14, 13, "#FF0000"],
            [9, 14, "#FF0000"],
            [7, 15, "#FF0000"],
            [8, 14, "#FF0000"],
            [12, 14, "#FF0000"],
            [11, 6, "#FF0000"],
            [12, 7, "#FF0000"],
            [13, 8, "#FF0000"],
            [14, 9, "#FF0000"],
            [15, 10, "#FF0000"],
            [16, 11, "#FF0000"],
            [16, 12, "#FF0000"],
            [15, 12, "#FF0000"],
            [11, 14, "#FF0000"],
            [10, 15, "#FF0000"],
            [9, 15, "#FF0000"],
            [17, 11, "#FF0000"],
            [15, 13, "#FF0000"],
            [14, 14, "#FF0000"],
            [13, 15, "#FF0000"],
            [12, 16, "#FF0000"],
            [11, 17, "#FF0000"],
            [10, 17, "#FF0000"],
            [9, 17, "#FF0000"],
            [8, 17, "#FF0000"],
            [7, 16, "#FF0000"],
            [6, 14, "#FF0000"],
            [6, 13, "#FF0000"],
            [7, 12, "#FF0000"],
            [8, 11, "#FF0000"],
            [8, 12, "#FF0000"],
            [7, 13, "#FF0000"],
            [7, 14, "#FF0000"],
            [8, 13, "#FF0000"],
            [9, 12, "#FF0000"],
            [9, 11, "#FF0000"],
            [9, 16, "#FF0000"],
            [10, 16, "#FF0000"],
            [8, 16, "#FF0000"],
            [11, 16, "#FF0000"],
            [11, 15, "#FF0000"],
            [12, 15, "#FF0000"],
            [13, 14, "#FF0000"],
            [15, 11, "#FF0000"],
            [13, 12, "#FF0000"],
            [12, 13, "#FF0000"],
            [9, 13, "#FF0000"],
            [11, 12, "#FF0000"],
            [12, 12, "#FF0000"],
            [10, 12, "#FF0000"],
            [10, 13, "#FF0000"],
            [10, 11, "#FF0000"],
            [12, 11, "#FF0000"],
            [11, 11, "#FF0000"],
            [13, 11, "#FF0000"],
            [7, 9, "#FF0000"],
            [6, 8, "#FF0000"],
            [6, 7, "#FF0000"],
            [7, 6, "#FF0000"],
            [8, 7, "#FF0000"],
            [7, 8, "#FF0000"],
            [8, 8, "#FF0000"],
            [7, 7, "#FF0000"],
            [8, 10, "#FF0000"],
            [8, 9, "#FF0000"],
            [16, 10, "#FF0000"],
            [15, 9, "#FF0000"],
            [14, 8, "#FF0000"],
            [13, 7, "#FF0000"],
            [12, 6, "#FF0000"],
            [11, 7, "#FF0000"],
            [11, 9, "#FF0000"],
            [13, 9, "#FF0000"],
            [14, 10, "#FF0000"],
            [12, 8, "#FF0000"],
            [12, 10, "#FF0000"],
            [11, 10, "#FF0000"],
            [10, 10, "#FF0000"],
            [9, 10, "#FF0000"],
            [9, 9, "#FF0000"],
            [10, 9, "#FF0000"],
            [10, 7, "#FF0000"],
            [9, 7, "#FF0000"],
            [9, 8, "#FF0000"],
            [11, 5, "#FF0000"],
            [10, 5, "#FF0000"],
            [9, 5, "#FF0000"],
            [8, 5, "#FF0000"],
            [10, 8, "#FF0000"],
            [6, 12, "#800000"],
            [5, 13, "#800000"],
            [4, 14, "#800000"],
            [5, 15, "#FF0000"],
            [4, 15, "#800000"],
            [5, 16, "#800000"],
            [6, 16, "#FF0000"],
            [6, 17, "#800000"],
            [7, 17, "#FF0000"],
            [7, 18, "#800000"],
            [8, 18, "#FF0000"],
            [9, 19, "#800000"],
            [9, 18, "#FF0000"],
            [10, 19, "#800000"],
            [10, 18, "#800000"],
            [11, 18, "#800000"],
            [12, 18, "#800000"],
            [12, 17, "#800000"],
            [13, 17, "#800000"],
            [13, 16, "#800000"],
            [14, 16, "#800000"],
            [14, 15, "#800000"],
            [15, 14, "#800000"],
            [15, 15, "#800000"],
            [16, 13, "#800000"],
            [16, 14, "#800000"],
            [17, 12, "#800000"],
            [17, 13, "#800000"],
            [18, 12, "#800000"],
            [18, 11, "#800000"],
            [18, 10, "#800000"],
            [17, 10, "#800000"],
            [19, 11, "#800000"],
            [17, 9, "#800000"],
            [16, 9, "#800000"],
            [16, 8, "#800000"],
            [15, 8, "#800000"],
            [15, 7, "#800000"],
            [14, 7, "#800000"],
            [14, 6, "#800000"],
            [13, 6, "#800000"],
            [13, 5, "#800000"],
            [12, 5, "#800000"],
            [12, 4, "#800000"],
            [11, 4, "#800000"],
            [10, 4, "#800000"],
            [9, 4, "#FF0000"],
            [8, 4, "#FF0000"],
            [10, 3, "#800000"],
            [9, 3, "#800000"],
            [7, 4, "#800000"],
            [7, 5, "#FF0000"],
            [6, 5, "#800000"],
            [6, 6, "#FF0000"],
            [5, 6, "#800000"],
            [5, 7, "#FF0000"],
            [4, 7, "#800000"],
            [4, 8, "#800000"],
            [5, 9, "#800000"],
            [6, 10, "#800000"],
            [6, 11, "#800000"],
            [8, 3, "#800000"],
            [8, 19, "#800000"],
            [7, 19, "#800000"],
            [6, 18, "#800000"],
            [5, 17, "#800000"],
            [4, 16, "#800000"],
            [3, 15, "#800000"],
            [3, 7, "#800000"],
            [4, 6, "#800000"],
            [5, 5, "#800000"],
            [6, 4, "#800000"],
            [7, 3, "#800000"],
            [8, 2, "#800000"],
            [9, 2, "#800000"],
            [8, 20, "#800000"],
            [9, 20, "#800000"],
            [5, 10, "#800000"],
            [5, 12, "#800000"],
            [4, 9, "#800000"],
            [4, 13, "#800000"],
            [3, 8, "#800000"],
            [3, 14, "#800000"],
            [2, 2, "#808080"],
            [2, 20, "#808080"],
            [20, 20, "#808080"],
            [20, 2, "#808080"],
            [18, 4, "#808080"],
            [18, 18, "#808080"],
            [4, 18, "#808080"],
            [4, 4, "#808080"],
            [4, 1, "#808080"],
            [18, 1, "#808080"],
            [4, 21, "#808080"],
            [18, 21, "#808080"],
            [21, 5, "#808080"],
            [21, 17, "#808080"],
            [1, 5, "#808080"],
            [1, 17, "#808080"],
        ],
    },
];
